module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-number",
    attrs: {
      "type": "button",
      "disabled": _vm.$attrs.disabled
    },
    on: {
      "click": function($event) {
        return _vm.decrement()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  })])]), _vm._v(" "), _c('input', _vm._b({
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "[0-9]*",
      "number": "",
      "required": ""
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.updateValue,
      "blur": _vm.updateValueWithBoundaries
    }
  }, 'input', _vm.$attrs, false)), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-number",
    attrs: {
      "type": "button",
      "disabled": _vm.$attrs.disabled
    },
    on: {
      "click": function($event) {
        return _vm.increment()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e09bf716"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/InputNumber.vue
// module id = 1072
// module chunks = 1